/* Danger-confirm dialog — destructive operations (delete def, re-ingest)
 * never fire on a single click. Built on the shared shadcn Dialog. */
import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from 'shared/components/ui/dialog';
import {
    AlertTriangle
} from 'lucide-react';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description: React.ReactNode;
    confirmLabel: string;
    tone?: 'danger' | 'primary';
    busy?: boolean;
    onConfirm: () => void;
};

export default function ConfirmDialog({
    open,
    onOpenChange,
    title,
    description,
    confirmLabel,
    tone = 'danger',
    busy = false,
    onConfirm
}: Props) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[440px]">
                <DialogHeader>
                    <DialogTitle style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8
                    }}>
                        <AlertTriangle size={18} color={tone === 'danger' ? 'var(--aps-danger)' : 'var(--aps-warning)'} />
                        {title}
                    </DialogTitle>
                    <DialogDescription asChild>
                        <div>{description}</div>
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <button className="aps-btn aps-btn-ghost" disabled={busy}
                        onClick={() => onOpenChange(false)}>
                        Cancel
                    </button>
                    <button
                        className={'aps-btn ' + (tone === 'danger' ? 'aps-btn-danger' : 'aps-btn-primary')}
                        disabled={busy}
                        onClick={onConfirm}
                    >
                        {busy ? 'Working…' : confirmLabel}
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
